// Stage 5 launch readiness: small hook that reports whether Stripe is in
// LIVE or TEST mode. Used by Footer + Pricing to gate the "test mode" copy.
//
// One in-memory cache per page load so 10 callers don't fan out 10 requests.

import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

export function useStripeMode() {
  const [mode, setMode] = useState(cache);

  useEffect(() => {
    if (cache) { setMode(cache); return; }
    if (inflight) {
      inflight.then((v) => setMode(v)).catch(() => setMode({ live: false, test: true }));
      return;
    }
    inflight = api.get("/payments/mode").then((r) => {
      cache = r.data;
      return cache;
    }).catch(() => {
      // On any failure, fall back to TEST messaging — safer than falsely
      // claiming we're live.
      cache = { live: false, test: true };
      return cache;
    });
    inflight.then((v) => setMode(v));
  }, []);

  return mode || { live: false, test: true };
}
